import React, { useEffect, useState } from "react";
import { Dimensions, View, ScrollView, Text } from "react-native";
import { id, styles } from "./ManageRoleCss";
import AppBar from "../Layout/AppBar";
import { Button } from "react-native-paper";
import SearchRole from "./Search Role/SearchRole";
import { GetAllRole } from "../../service/api/role/api";
import RoleTable from "./Role Table/RoleTable";
import CreateRoleModal from "./Permission Modal/CreateRoleModal";
import { useDispatch, useSelector } from "react-redux";
import { setRoleDetails } from "../../store/slices/rolePermissionSlice";
import { showToast } from "../../constant/toastMessage";
import { primaryColor } from "../../constant/constantCss";
import { PERMISSION } from "../../constant/getAllPermission";
import PlaneLoader from "../../components/Loader";

const ManageRole = () => {
  const PAGE_SIZE = 10;
  const { height, width } = Dimensions.get("window");
  const [page, setPage] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const roleList = useSelector((state) => state.rolePermission.roleDetails);
  const { permission } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [isVisibleCreateRoleModal, setIsVisibleCreateRoleModal] =
    useState(false);
  useEffect(() => {
    setLoader(true);
    GetAllRole(page + 1)
      .then((res) => {
        dispatch(setRoleDetails(res?.data?.results));
        setNoOfPage(Math.ceil(res?.data?.count / PAGE_SIZE));
        setLoader(false);
      })
      .catch((err) => {
        showToast("error", err?.response?.data?.detail);
        setLoader(false);
      });
  }, [page]);

  return (
    <View style={[styles.container, { minHeight: height }]}>
      <AppBar />
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.subContainer}>
          <View style={styles.flexRow}>
            <Text style={styles.headingText}>Role List</Text>
            {permission && permission?.includes(PERMISSION.CAN_CREATE_ROLE) && (
              <Button
                icon={"plus"}
                mode="contained"
                buttonColor={primaryColor}
                onPress={() => setIsVisibleCreateRoleModal(true)}
              >
                {width >= 480 && "Add Role"}
              </Button>
            )}
          </View>
          {loader ? (
            <PlaneLoader />
          ) : (
            <>
              <SearchRole />
              {roleList?.length > 0 ? (
                <>
                  <RoleTable
                    page={page}
                    setPage={setPage}
                    noOfPage={noOfPage}
                  />
                  {isVisibleCreateRoleModal && (
                    <CreateRoleModal
                      visible={isVisibleCreateRoleModal}
                      handleClose={() => setIsVisibleCreateRoleModal(false)}
                    />
                  )}
                </>
              ) : (
                <Text>No Role found!</Text>
              )}
            </>
          )}
        </View>
      </ScrollView>
    </View>
  );
};

export default ManageRole;
